import { Injectable } from '@angular/core';
import { HttpService } from '../http/http.service';
import { AlertService } from '../alert/alert.service';
import { Global } from '../../helpers/global';
import { EmpresaModel } from 'src/app/models/empresaModel';
import { GrupoModel } from 'src/app/models/grupoModel';
import { ProdutoModel, DetalheProdutoModel, DetalheProdutoGrupoAcompanhamentoModel } from 'src/app/models/produtoModel';
import { RetornoModel } from 'src/app/models/retornoModel';
import { CarrinhoModel } from 'src/app/models/carrinhoModel';
import { SpinnerService } from '../spinner/spinner.service';
import { AcompanhamentoModel, DetalheAcompanhamentoModel, DetalheProdutoAcompanhamentoModel } from 'src/app/models/acompanhamentoModel';
import { IdentificacaoModel } from 'src/app/models/identificacaoModel';
import { enTipoAcompanhamento } from 'src/app/models/enums/enTipoAcompanhamento';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';

@Injectable({
  providedIn: 'root'
})
export class DeliveryService {
  _empresa: EmpresaModel;
  _grupoProduto: GrupoModel;
  _produto: ProdutoModel;
  _imagensProduto: DetalheProdutoModel[];
  _observacaoPedido: string;
  _acompanhamento: AcompanhamentoModel;

  constructor(private httpSrv: HttpService,
    //private storage: Storage,
    private alertaSrv: AlertService,
    private spinnerSrv: SpinnerService,
    private browserSrv: InAppBrowser) { }

  public async ResetarInformacaoCache() {
    Global.Empresa = null;
    Global.GrupoProduto = null;
    Global.Produto = null;
    Global.ObservacaoPedido = null;
    Global.Acompanhamento = null;
  }

  public async AcaoSairDoSistema(): Promise<void> {
    let c = (() => {
      navigator['app'].exitApp();
    });

    await this.alertaSrv.Confirma("Sair do sistema", "Deseja realmente sair?", false, c, null);
  }

  async CarregarinformacoesFuncionamentoSistema(identificaNovamente: boolean): Promise<void> {
    //let VinculoTablet = false;
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        if (identificaNovamente) {
          let identificacao = await this.IdentificarEmpresa();
          if (identificacao) {
            Global.IdentificacaoEmpresa = identificacao.Id;
            Global.CodigoMesa = identificacao.CodigoMesa;
            Global.CodigoMesaCripto = identificacao.CodigoMesaCripto;
            Global.PermiteCriarPedido = identificacao.PermiteCriarPedido;
            Global.EhDispositivoVinculado = identificacao.EhDispositivoVinculado;
            if(identificacao.VinculoTablet && identificacao.UrlChamadoraAjustada)
              Global.UrlChamadora = identificacao.UrlChamadoraAjustada;
            //VinculoTablet = identificacao.VinculoTablet;
          }
        }

        this._empresa = await this.httpSrv.CarregarInformacoesEmpresa();
        if (this._empresa) {
          Global.Empresa = this._empresa;
        }

        this._grupoProduto = await this.httpSrv.CarregarInformacoesGrupoProduto();
        if (this._grupoProduto) {
          Global.GrupoProduto = this._grupoProduto;
        }

        await this.CarregarInformacoesProdutos();
        await this.CarregarFotosProdutos();

        this._observacaoPedido = "";
        this.GravarinformacoesObservacaoPedido(this._observacaoPedido);
        Global.QuantidadeItensCarrinho = 0;

        this._acompanhamento = await this.httpSrv.CarregarInformacoesAcompanhamentoPedido();
        if (this._acompanhamento) {
          Global.Acompanhamento = this._acompanhamento;
        }

        resolve();
      });
    };

    await c()
      .then(res => {

        let s = "";

        // Verifico se carregou as informações de EMPRESA
        if (!this._empresa.Sucesso) {
          s += (this._empresa.Mensagem)
            ? "* Erro carregando informações de Empresas<br/>"
            : "";
        }

        // Verifico se carregou as informações de Grupo de Produtos
        if (!this._grupoProduto.Sucesso) {
          // s += (this._grupoProduto.Mensagem)
          //   ? this._grupoProduto.Mensagem + "\n"
          //   : "* Erro carregando informações de Grupo de Produtos\n";
          s += (this._grupoProduto.Mensagem)
            ? "* Erro carregando informações de Grupo de Produtos<br/>"
            : "";
        }

        // Verifico se carregou as informações de PRODUTO
        if (!this._produto.Sucesso) {
          // s += (this._produto.Mensagem)
          //   ? this._produto.Mensagem + "\n"
          //   : "* Erro carregando informações de Produtos\n";
          s += (this._produto.Mensagem)
            ? "* Erro carregando informações de Produtos<br/>"
            : "";
        }

        // Verifico se carregou as informações de Grupo de Produtos
        if ((this._acompanhamento) && (!this._acompanhamento.Sucesso)) {
          // s += (this._acompanhamento.Mensagem)
          //   ? this._acompanhamento.Mensagem + "\n"
          //   : "* Erro carregando informações de Acompanhamentos\n";
          s += (this._acompanhamento.Mensagem)
            ? "* Erro carregando informações de Acompanhamentos\n"
            : "";
        }

        if (s) {
          let mensagem = "Erro carregando informações<br/>" + s + "<br/><br/>Pressione F5"
          this.alertaSrv.Alerta("Erro carregando informações", mensagem, false);
        }
        else {
          if (!Global.PermiteCriarPedido && Global.CodigoMesaPedido) {
            this.alertaSrv.Alerta("Alerta",
              "O atendimento deste pedido não foi localizado ou já foi finalizado.\nChame um garçom para verificar.",
              false);
          }
        }
      })
      .catch(e => {
        this.alertaSrv.Alerta("Erro", "Erro desconhecido. Pressione F5", false);
        console.log(e)
      })
      .finally(() => {
      });
  }

  async CarregarInformacoesProdutos() {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        if (Global.PaginaAtualPesquisaProduto == 1) {
          this._produto = new ProdutoModel();
          this._produto.Relacao = [];
          this._produto.RelacaoCarrinho = [];
          this._imagensProduto = [];
        }

        let produto: ProdutoModel = await this.httpSrv.CarregarInformacoesProdutos(Global.PaginaAtualPesquisaProduto);

        if ((produto) &&
          (produto.Sucesso) &&
          (produto.Relacao)) {
          produto.Relacao.forEach(e => {
            if (this._produto.Relacao.findIndex(r => r.Codigo == e.Codigo) == -1) {
              this._produto.Relacao.push(e);
            }
          })

          Global.PaginaAtualPesquisaProduto++;

          await this.onGravarConteudoStorageProduto();
        }
        resolve();
      });
    };

    await c()
      .then(res => {
      })
      .catch(e => {
        console.log(e);
      });
  }

  async CarregarInformacoesEmMemoria(): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {

        // let identificacao = await this.IdentificarEmpresa();
        // if (identificacao) {
        //   Global.IdentificacaoEmpresa = identificacao.Id;
        // }

        this._empresa = Global.Empresa;
        this._grupoProduto = Global.GrupoProduto;
        await this.onCarregarConteudoStorageProduto();
        this._observacaoPedido = Global.ObservacaoPedido;
        this._acompanhamento = Global.Acompanhamento;

        await this.SelecionarProdutosComprados();

        resolve();
      });
    };

    await c()
      .then(res => {
      })
      .catch(e => {
        console.log(e);
      });
  }

  SelecionarProdutosDeGrupo(codigoGrupo: number): DetalheProdutoModel[] {
    let relacao: DetalheProdutoModel[] = [];

    let c = async () => {
      return new Promise(async (resolve) => {
        if (this._produto.Relacao) {
          this._produto.Relacao.forEach(e => {
            if (e.CodigoGrupo === codigoGrupo) {
              relacao.push(e);
            }
            e.Quantidade = 1;
          });
        }

        resolve(relacao);
      });
    };

    c().then(res => { }).catch(e => { console.log(e); });
    return relacao;
  };

  AdicionarProdutoAoCarrinho(codigoProduto: number,
    quantidade: number,
    observacao: string,
    relacaoAcompanhamento: DetalheProdutoGrupoAcompanhamentoModel[],
    valorTotal: number) {

    let index = -1;
    for (let i = 0; i < this._produto.Relacao.length; i++) {
      let x = this._produto.Relacao.findIndex(y => y.Codigo == codigoProduto);

      if (x > -1) {
        index = x;
        break;
      }
    }

    if (index > -1) {
      let produto = this._produto.Relacao[index];
      produto.Quantidade = 1;
      produto.ObservacaoNoPedido = "";

      let produtoCarrinho: DetalheProdutoModel = new DetalheProdutoModel();
      produtoCarrinho.SequencialCarrinho = this._produto.RelacaoCarrinho.length;
      produtoCarrinho.Codigo = produto.Codigo;
      produtoCarrinho.CodigoGrupo = produto.CodigoGrupo;
      produtoCarrinho.Nome = produto.Nome;
      produtoCarrinho.PossuiDesconto = produto.PossuiDesconto;
      produtoCarrinho.Descricao = produto.Descricao;
      produtoCarrinho.ValorNutricional = produto.ValorNutricional;
      produtoCarrinho.Avisos = produto.Avisos;
      produtoCarrinho.PathImagem = produto.PathImagem;
      produtoCarrinho.Preco = produto.Preco;
      produtoCarrinho.RelacaoGrupoAcompanhamento = produto.RelacaoGrupoAcompanhamento;

      produtoCarrinho.ObservacaoNoPedido = observacao;
      produtoCarrinho.Quantidade = quantidade;
      produtoCarrinho.ValorTotal = Math.round((valorTotal) * 100.00) / 100.00;

      produtoCarrinho.RelacaoAcompanhamentoCarrinho = this.CarregarAcompanhamentosProduto(produtoCarrinho.Codigo);

      if (relacaoAcompanhamento) {
        relacaoAcompanhamento.forEach(g => {

          let indexGrupo: number = produtoCarrinho.RelacaoAcompanhamentoCarrinho.findIndex(x => x.CodigoGrupoAcompanhamento == g.CodigoGrupoAcompanhamento);

          g.RelacaoAcompanhamento.forEach(a => {
            let indexAcomp = produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento.findIndex(x => x.Codigo == a.Codigo);
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Selecionado = a.Selecionado;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].QuantidadeSelecionada = a.QuantidadeSelecionada;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Posicao1 = a.Posicao1;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Posicao2 = a.Posicao2;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Posicao3 = a.Posicao3;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Posicao4 = a.Posicao4;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Pizza = a.Pizza;
            produtoCarrinho.RelacaoAcompanhamentoCarrinho[indexGrupo].RelacaoAcompanhamento[indexAcomp].Sabores = a.Sabores;

            if (a.Selecionado) {
              //produtoCarrinho.ValorTotal += Math.round(((a.ValorAcompanhamento * a.QuantidadeSelecionada) * produtoCarrinho.Quantidade) * 100.00) / 100.00;
            }
          });
        });
      }

      this._produto.RelacaoCarrinho.push(produtoCarrinho);

      this.onGravarConteudoStorageProduto();

      // Adiciono o produto no carrinho 
      Global.QuantidadeItensCarrinho += produtoCarrinho.Quantidade;

      produto.MensagemAdicionado = true;
      setTimeout(() => {
        produto.MensagemAdicionado = false;
      }, 1000);

      //this.alertaSrv.MensagemPopUp("Adicionado ao Carrinho...");
    }
  }

  private async onGravarConteudoStorageProduto(): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        this._produto.RelacaoCarrinho.forEach(e => {
          e.PathImagem = '';
        })

        Global.Produto = this._produto;
        resolve();
      });
    };

    let ret: string = '';
    await c().then(res => { })
      .catch(e => console.log(e));
  }

  private async onCarregarConteudoStorageProduto(): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        //this._produto = Global.Produto

        if (this._produto) {
          this._produto.RelacaoCarrinho.forEach(e => {
            let index: number = this._produto.Relacao.findIndex(x => x.Codigo == e.Codigo);
            e.PathImagem = this._produto.Relacao[index].PathImagem;
          });
        }

        resolve();
      });
    };

    let ret: string = '';
    await c().then(res => { })
      .catch(e => console.log(e));
  }

  async CarregarFotosProdutos() {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        //Mantenho a lista carregada, para o caso de não sincronizado
        let produto: ProdutoModel = await this.httpSrv.CarregarInformacoesImagensProdutos(Global.PaginaAtualPesquisaImagemProduto);
        if ((produto.Sucesso) &&
          (produto.Relacao)) {
          produto.Relacao.forEach(e => {
            this._imagensProduto.push(e);
          })
        }

        if ((this._imagensProduto) &&
          (this._produto) &&
          (this._produto.Relacao)) {
          this._produto.Relacao.forEach(e => {
            let index: number = this._imagensProduto.findIndex(x => x.Codigo == e.Codigo);
            if (index > -1)
              e.PathImagem = this._imagensProduto[index].PathImagem;
          })

          Global.PaginaAtualPesquisaImagemProduto++;

          await this.onGravarConteudoStorageProduto();
        }

        if ((produto) &&
          (!produto.Relacao)) {
          this._produto.Relacao.forEach(e => {
            if (e.PathImagem == "../../../assets/carregando.gif")
              e.PathImagem = "../../../assets/noImage.png"
          })

        }

        resolve();
      });
    };

    await c()
      .then(res => {
      })
      .catch(e => {
        console.log(e);
      });
  }

  AtualizarProdutoAoCarrinho(produto: DetalheProdutoModel) {
    if (produto.Quantidade == 0) {
      this.alertaSrv.Alerta("Quantidade", "Informe uma quantidade válida deste produto", true);
      return;
    }

    let index: number = this._produto.RelacaoCarrinho.findIndex(y => y.SequencialCarrinho == produto.SequencialCarrinho);
    this._produto.RelacaoCarrinho[index] = produto;

    this.onGravarConteudoStorageProduto();

    this.alertaSrv.MensagemPopUp("Produto Atualizado no Pedido...");
  }

  CarregarAcompanhamentosProduto(codigoProduto: number): DetalheProdutoGrupoAcompanhamentoModel[] {
    let retorno: DetalheProdutoGrupoAcompanhamentoModel[] = []

    if ((this._produto.Relacao) &&
      (this._acompanhamento) &&
      (this._acompanhamento.Relacao)) {
      let index = this._produto.Relacao.findIndex(y => y.Codigo == codigoProduto);
      let produto = this._produto.Relacao[index];

      if (produto.RelacaoGrupoAcompanhamento) {
        produto.RelacaoGrupoAcompanhamento.forEach(c => {
          let acompanhamentoCarrinho = new DetalheProdutoGrupoAcompanhamentoModel();
          acompanhamentoCarrinho.CodigoGrupoAcompanhamento = c.CodigoGrupoAcompanhamento;
          acompanhamentoCarrinho.RelacaoAcompanhamento = [];

          this._acompanhamento.Relacao.forEach(y => {
            if (acompanhamentoCarrinho.CodigoGrupoAcompanhamento == y.CodigoGrupoAcompanhamento) {
              acompanhamentoCarrinho.QuantidadeMaximaGrupo = y.QuantidadeMaximaGrupo;
              acompanhamentoCarrinho.NomeGrupo = y.NomeGrupoAcompanhamento;
              acompanhamentoCarrinho.ID = acompanhamentoCarrinho.NomeGrupo.split(' ').join('_');
              acompanhamentoCarrinho.Link = "#" + acompanhamentoCarrinho.NomeGrupo.split(' ').join('_');
              acompanhamentoCarrinho.Obrigatorio = y.Obrigatorio;
              acompanhamentoCarrinho.MaiorValor = y.MaiorValor;
              acompanhamentoCarrinho.Pizza = y.Pizza;
              //acompanhamentoCarrinho.QuantidadeSelecionadaGrupo = 0;

              let acompanhamentoProduto: DetalheProdutoAcompanhamentoModel = new DetalheProdutoAcompanhamentoModel();
              acompanhamentoProduto.CodigoGrupoAcompanhamento = acompanhamentoCarrinho.CodigoGrupoAcompanhamento;
              acompanhamentoProduto.NomeGrupoAcompanhamento = acompanhamentoCarrinho.NomeGrupo;
              acompanhamentoProduto.Codigo = y.Codigo;
              acompanhamentoProduto.Acompanhamento = y.Acompanhamento;
              acompanhamentoProduto.DetalhesAcompanhamento = y.DetalhesAcompanhamento;
              acompanhamentoProduto.QuantidadeMaximaAcompanhamento = y.QuantidadeMaximaAcompanhamento;
              acompanhamentoProduto.ValorAcompanhamento = y.ValorAcompanhamento;
              if (y.RelacaoProdutoAcompanhamento) {
                y.RelacaoProdutoAcompanhamento.forEach(x => {
                  if (x.CodigoProduto == codigoProduto) {
                    acompanhamentoProduto.CodigoProdutoAcompanhamento = x.CodigoProdutoAcompanhamento;
                    acompanhamentoProduto.QuantidadeProdutoAcompanhamento = x.QuantidadeProdutoAcompanhamento;
                  }
                });
              }

              if (acompanhamentoProduto.Selecionado == undefined) {
                acompanhamentoProduto.Selecionado = false;
              }
              acompanhamentoProduto.QuantidadeSelecionada = 0;

              acompanhamentoCarrinho.RelacaoAcompanhamento.push(acompanhamentoProduto);
            }
          });

          if (acompanhamentoCarrinho.RelacaoAcompanhamento.length > 0) {
            retorno.push(acompanhamentoCarrinho);
          }
        });
      }
    }

    return retorno;
  }

  async SelecionarProdutosComprados(): Promise<DetalheProdutoModel[]> {
    let relacao: DetalheProdutoModel[] = [];
    Global.QuantidadeItensCarrinho = 0;

    let c = async () => {
      return new Promise(async (resolve) => {
        if ((this._produto) &&
          (this._produto.RelacaoCarrinho)) {
          this._produto.RelacaoCarrinho.forEach(e => {

            let index: number = this._produto.Relacao.findIndex(x => x.Codigo == e.Codigo);
            e.PathImagem = this._produto.Relacao[index].PathImagem;
            Global.QuantidadeItensCarrinho += e.Quantidade;
            relacao.push(e);
          });
        }

        resolve(relacao);
      });
    };

    await c().then(res => { }).catch(e => { console.log(e); });
    return relacao;
  }

  async SincronizarCarrinhoCompra(carrinho: CarrinhoModel,
    relacaoProdutos: DetalheProdutoModel[],
    relacaoAcompanhamento: DetalheAcompanhamentoModel[]): Promise<RetornoModel> {
    let c = async () => {
      return new Promise(async (resolve) => {

        let r: RetornoModel = await this.httpSrv.SincronizarCarrinhoCompra(carrinho, relacaoProdutos, relacaoAcompanhamento);

        resolve(r);
      });
    };

    let ret: RetornoModel = new RetornoModel();
    await c().then(res => { ret = (res as RetornoModel); })
      .catch(e => {
        ret.Erro = true;
        ret.Mensagem = String(e) + String(e.error);
        console.log(e);
      });
    return ret;
  }

  async ReiniciarOperacao() {
    Global.PaginaAtualPesquisaProduto = 1;
    Global.CarregamentoCompleto = false;
    Global.PaginaAtualPesquisaImagemProduto = 1;
    Global.CarregamentoCompletoImagem = false;
    await this.CarregarinformacoesFuncionamentoSistema(true);
  }

  async AtualizarProdutoCarrinhoCompra(sequencial: number, quantidade: number): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        let index = -1;
        for (let i = 0; i < this._produto.RelacaoCarrinho.length; i++) {
          let x = this._produto.RelacaoCarrinho.findIndex(y => y.SequencialCarrinho === sequencial);

          if (x > -1) {
            index = x;
            break;
          }
        }

        if (index > -1) {
          this._produto.RelacaoCarrinho[index].Quantidade = quantidade;
          this._produto.RelacaoCarrinho[index].ValorTotal = Math.round((this._produto.RelacaoCarrinho[index].Quantidade * this._produto.RelacaoCarrinho[index].Preco) * 100.00) / 100.00;

          if (this._produto.RelacaoCarrinho[index].RelacaoAcompanhamentoCarrinho) {
            this._produto.RelacaoCarrinho[index].RelacaoAcompanhamentoCarrinho.forEach(g => {
              g.RelacaoAcompanhamento.forEach(a => {
                if (a.Selecionado) {
                  this._produto.RelacaoCarrinho[index].ValorTotal += Math.round(((a.ValorAcompanhamento * a.QuantidadeSelecionada) * this._produto.RelacaoCarrinho[index].Quantidade) * 100.00) / 100.00;
                }
              });
            });
          }

          this.onGravarConteudoStorageProduto();
        }
        resolve();
      });
    };

    await c().then(res => { }).catch(e => { console.log(e); });
  }

  async AtualizarObservacaoProdutoCarrinhoCompra(sequencial: number, observacao: string): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        let index = -1;
        for (let i = 0; i < this._produto.RelacaoCarrinho.length; i++) {
          let x = this._produto.RelacaoCarrinho.findIndex(y => y.SequencialCarrinho === sequencial);

          if (x > -1) {
            index = x;
            break;
          }
        }

        if (index > -1) {
          this._produto.RelacaoCarrinho[index].ObservacaoNoPedido = observacao;

          this.onGravarConteudoStorageProduto();
        }
        resolve();
      });
    };

    await c().then(res => { }).catch(e => { console.log(e); });
  }

  async RemoverProdutoCarrinhoCompra(sequencial: number): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        let index = -1;
        for (let i = 0; i < this._produto.RelacaoCarrinho.length; i++) {
          let x = this._produto.RelacaoCarrinho.findIndex(y => y.SequencialCarrinho === sequencial);

          if (x > -1) {
            index = x;
            break;
          }
        }

        if (index > -1) {
          Global.QuantidadeItensCarrinho -= this._produto.Relacao[index].Quantidade;
          this._produto.RelacaoCarrinho.splice(index, 1);
        }

        this.onGravarConteudoStorageProduto();

        resolve();
      });
    };

    await c().then(res => { }).catch(e => { console.log(e); });
  }

  public GravarinformacoesObservacaoPedido(observacao: string) {
    Global.ObservacaoPedido = observacao;
    //this.GravarConteudoStorage(Global.ChaveObservacaoPedido, observacao);
  }

  async CarregarAcompanhamentoPedido(): Promise<DetalheAcompanhamentoModel[]> {
    let relacao: DetalheAcompanhamentoModel[] = [];

    let c = async () => {
      return new Promise(async (resolve) => {
        if (this._acompanhamento.Relacao) {
          this._acompanhamento.Relacao.forEach(e => {
            if (e.TipoAcompanhamento == enTipoAcompanhamento.Pedido) {
              e.ValorAcompanhamento = 0.00;
              relacao.push(e);
            }
          })
        }

        resolve(relacao);
      });
    };

    await c().then(res => { }).catch(e => { console.log(e); });
    return relacao;
  }

  async AtualizarAcompanhamentoCarrinhoCompra(codigo: number, quantidade: number): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        let index = -1;
        for (let i = 0; i < this._acompanhamento.Relacao.length; i++) {
          let x = this._acompanhamento.Relacao.findIndex(y => y.Codigo === codigo);

          if (x > -1) {
            index = x;
            break;
          }
        }

        if (index > -1) {
          this._acompanhamento.Relacao[index].QuantidadeSelecionada = quantidade;

          Global.Acompanhamento = this._acompanhamento;
        }
        resolve();
      });
    };

    await c()
      .then(res => { })
      .catch(e => { console.log(e); });
  }

  async IdentificarEmpresa(): Promise<IdentificacaoModel> {
    let retorno: IdentificacaoModel = new IdentificacaoModel();

    let c = async () => {
      return new Promise(async (resolve) => {
        let r: IdentificacaoModel = await this.httpSrv.IdentificarEmpresa();
        resolve(r);
      });
    };

    await c()
      .then(res => {
        retorno = (res as IdentificacaoModel);
        if (!retorno.ExibirAoConsumidor && !retorno.EmpresaAtiva) {
          retorno.Mensagem = "Empresa está desativada no sistema...";
        }
      })
      .catch(e => {
        this.alertaSrv.Alerta("Erro", "Erro localizando a ID desta empresa", false);
        console.log(e)
      })
      .finally(() => {
        //this.spinnerSrv.Hide();
      });

    return retorno;
  }

  async AtualizarAcompanhamentoProdutoCarrinhoCompra(produto: DetalheProdutoModel, acompanhamentoProduto: DetalheAcompanhamentoModel): Promise<void> {
    let c = async () => {
      return new Promise<void>(async (resolve) => {
        resolve();
      });
    };

    await c()
      .then(res => {
        this.onGravarConteudoStorageProduto();
      })
      .catch(e => { console.log(e); });
  }

  RealizarEnvioPedidosViaWhatsapp(carrinho: CarrinhoModel,
    codigoCarrinho: any,
    tempoAtendimento: any) {
    if ((carrinho) && (this._empresa.Whatsapp)) {
      let replicate: string = "-------------------------------\n";
      let valorTotal: number = 0.00;
      let url: string = "https://wa.me/" + this._empresa.Whatsapp + "?text=";
      let pedido: string = "Olá " + this._empresa.Nome + "!!!\n";
      pedido += "Foi realizado um pedido no seu app com os seguintes DADOS:\n";

      pedido += replicate;
      pedido += "*Código do PEDIDO*: " + codigoCarrinho + "\n";
      pedido += "*Atendimento*: " + tempoAtendimento + "\n";

      pedido += replicate;
      //pedido += "*Cliente*: " + carrinho.Nome + "\n";
      //pedido += "Email/Telefone: " + carrinho.Telefone + "\n";
      pedido += replicate;

      // if (carrinho.CPF) {
      //   pedido += "*CPF NA NOTA*: " + (carrinho.CPF.length == 11 ? (carrinho.CPF.substring(0, 3) + "." + carrinho.CPF.substring(3, 6) + "." + carrinho.CPF.substring(6, 9) + "-" + carrinho.CPF.substring(9, 11)) : carrinho.CPF) + "\n";
      //   pedido += replicate;
      // }

      pedido += "*PRODUTOS*\n";

      this._produto.RelacaoCarrinho.forEach(p => {
        valorTotal += p.ValorTotal;
        pedido += replicate;
        pedido += "- " + p.Nome + "\n";
        pedido += "Qtd: " + p.Quantidade + "\n";
        pedido += "Total: " + Global.FormatarMoeda(p.ValorTotal) + "\n";

        if (p.ObservacaoNoPedido) {
          pedido += "*Obs. deste Item*: " + p.ObservacaoNoPedido + "\n";
        }
      });

      pedido += replicate;

      if ((this._acompanhamento.Relacao) && (this._acompanhamento.Relacao.filter(rel => rel.QuantidadeSelecionada > 0).length > 0)) {
        pedido += "*ACOMPANHAMENTOS*\n";

        this._acompanhamento.Relacao.forEach(a => {
          if (a.QuantidadeSelecionada > 0) {
            pedido += replicate;
            pedido += "- " + a.Acompanhamento + "\n";
            pedido += "Qtd: " + a.QuantidadeSelecionada + "\n";
          }
        })
        pedido += replicate;
      }

      if (carrinho.Observacao) {
        pedido += "*Obs. do Pedido*: " + carrinho.Observacao + "\n";
        pedido += replicate;
      }

      pedido += "*Total Pedido*: " + Global.FormatarMoeda(valorTotal) + "\n";
      pedido += "\n";

      url += encodeURIComponent(pedido);

      if (!Global.EhProducao) {
        console.log(url);
      }

      const browser = this.browserSrv.create(url);
      browser.show();
    }
  }

  async RegistrarAcessoAplicacao(): Promise<RetornoModel> {
    let retorno: RetornoModel = new RetornoModel();

    let c = async () => {
      return new Promise(async (resolve) => {
        let r: RetornoModel = await this.httpSrv.RegistrarAcessoAplicacao();
        resolve(r);
      });
    };

    await c()
      .then(res => {
        retorno = (res as RetornoModel);
      })
      .catch(e => {
        console.log(e)
      })
      .finally(() => {
        //this.spinnerSrv.Hide();
      });

    return retorno;
  }

  async FecharMesaPedido(): Promise<RetornoModel> {
    let c = async () => {
      return new Promise(async (resolve) => {

        let r: RetornoModel = await this.httpSrv.FecharMesaPedido();

        resolve(r);
      });
    };

    let ret: RetornoModel = new RetornoModel();
    await c().then(res => { ret = (res as RetornoModel); })
      .catch(e => {
        ret.Erro = true;
        ret.Mensagem = String(e) + String(e.error);
        console.log(e);
      });
    return ret;
  }

  setItem(key: string, value: string, ttlInMinutes: number): void {
    const now = Date.now();
    const item = {
      value: value,
      expiry: now + ttlInMinutes * 60 * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
  }

  // getItem(key: string): string | null {
  //   const itemStr = localStorage.getItem(key);
  //   if (!itemStr) {
  //     return null;
  //   }

  //   try {
  //     let item = JSON.parse(itemStr);
  //     const now = new Date();
  //     if (now.getTime() > item.expiry) {
  //       localStorage.removeItem(key);
  //       return null;
  //     }
  //     return item.value;
  //   } catch (e) {
  //     // Se por acaso o JSON estiver malformado
  //     localStorage.removeItem(key);
  //     return null;
  //   }
  // }

  getItem(key: string): string | null {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) {
      return null;
    }

    try {
      const item = JSON.parse(itemStr);

      if (!item || typeof item.expiry !== 'number' || !('value' in item)) {
        // Estrutura inválida — remove e retorna null
        localStorage.removeItem(key);
        return null;
      }

      const now = Date.now();
      if (now > item.expiry) {
        localStorage.removeItem(key);
        return null;
      }

      return item.value;
    } catch (e) {
      // Se o JSON estiver malformado
      localStorage.removeItem(key);
      return null;
    }
  }

  removeItem(key: string): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }
}
